import type { ReactNode } from "react";
import { ReactComponent as PenToolIcon } from "../../../../../assets/icons/PenToolIcon.svg";
import { ReactComponent as CodeIcon } from "../../../../../assets/icons/CodeIcon.svg";
import { ReactComponent as FileTextIcon } from "../../../../../assets/icons/FileTextIcon.svg";
import { ReactComponent as ChatAlertIcon } from "../../../../../assets/icons/ChatAlertIcon.svg";
import { ReactComponent as GlobeIcon } from "../../../../../assets/icons/GlobeIcon.svg";
import { ReactComponent as SearchLineIcon } from "../../../../../assets/icons/SearchLineIcon.svg";

export const roleIcons: ReactNode[] = [
    <PenToolIcon />,
    <CodeIcon />,
    <FileTextIcon />,
    <ChatAlertIcon />,
    <GlobeIcon />,
    <SearchLineIcon />,
];
